import _ from 'lodash';
import { compileCriteria } from 'view/webServiceCaller/data-operations';

export default {
	computed: {
		availableSimulateItemsList() {
			let data = this.visibleTracks.reduce((arr, track) => {
				let insertion = track.insertion;
				if (insertion?.EventRule?.Oid && !_.find(arr, v => v?.Oid === insertion?.EventRule?.Oid))
					arr.push({ ...insertion?.EventRule, __type: 'rule' });
				insertion?.Targets?.map((t) => {
					let target = t?.LinkedTarget;
					if (!_.find(arr, v => v?.Oid === target?.Oid))
						arr.push({ ...target, __type: 'geo-target' });
				});
				return arr;
			}, []);

			return _.orderBy(data, '__type', 'Name');
		},
		dropdownRuleItems() {
			let arr = [];
			if (this.availableSimulateItemsList.length) {
				arr.push(
					{
						id: 'clear',
						text: this.$tCaption('Clear all'),
						onClick: () => this.clearSimulateRules()
					}
				);
			}
			arr.push(...this.availableSimulateItemsList.map(f => ({
				id: f.Oid,
				icon: `creative-detail--simulation-rule-icon ${f.__type === 'rule' ? 'fas fa-calendar-check' : 'fas fa-map-marker-alt'} ${this.simulateRules.indexOf(f.Oid) > -1 ? 'active' : ''}`,
				text: f.Name,
				onClick: () => this.toggleSimulateItem(f)
			})));
			return arr;
		},
	},
	data() {
		return {
			rules: [],
			simulateRules: [],
			simulateItemClicked: false,
			simulatedItems: {}
		}
	},
	methods: {
		checkSimulateRules(track) {
			if (!track.subTracks.length || track.__isSubTrack) {
				if (!track.__isSubTrack)
					track.__internallyMuted = false;
				return;
			}
			let subTracksSimulated = false;
			track.subTracks.map(subTrack => {
				let hasSimulationItems = subTrack.insertion?.EventRule?.Oid || subTrack.insertion?.Targets?.length;
				let hasEventRuleSimulated = subTrack.insertion?.EventRule?.Oid && this.simulateRules.indexOf(subTrack.insertion.EventRule.Oid) > -1;
				let hasTargetsSimulated = subTrack.insertion?.Targets?.some(t => this.simulateRules.indexOf(t.LinkedTarget.Oid) > -1);
				if (subTrack)
					subTrack.__internallyMuted = hasSimulationItems && (subTracksSimulated || (subTrack.__isServersideCalculated() && !(hasEventRuleSimulated || hasTargetsSimulated)));
				subTracksSimulated = subTracksSimulated || (hasEventRuleSimulated || hasTargetsSimulated);
			});
			track.__internallyMuted = subTracksSimulated;

			if (subTracksSimulated) {
				this.onSetSoloSubTracks(track.subTracks.filter(f => !f.__internallyMuted));
			}
		},
		checkSimulateRulesAllTracks() {
			if (this.isPublishMode) return;
			this.visibleTracks.map(f => {
				this.checkSimulateRules(f);
			});
			if (this.$refs.tracker)
				this.$refs.tracker.refreshPlay();
		},
		clearSimulateRules() {
			this.simulateRules = [];
		},
		toggleSimulateItem(item) {
			if (item.__type === 'geo-target') {
				if (this.simulateRules[0] === item.Oid)
					this.simulateRules = []
				else
					this.simulateRules = [item.Oid];
			} else {
				this.$Data.toggleSelectedIdInArray(item.Oid, this.simulateRules);
			}
		},
		onSimulateRulesPopupChanged(res, ids) {
			if (__DEBUG__)
				console.debug('onSimulateRulesPopupChanged', { res, ids });
			this.simulateRules = ids;

			let simulatedParams = res?.trackCriteriaParams || [];

			let resObj = {};
			simulatedParams.map(p => {
				let split = p.path.split('.');
				resObj[split[0]] = {};
				resObj[split[0]][split[1]] = p.value;
			});

			let criteriaAggTracks = this.$refs.tracker.aggregatedTracks.filter(f => f.condition);
			criteriaAggTracks.map(aggTrack => {
				aggTrack.__internallyMuted = simulatedParams?.length && !(compileCriteria(aggTrack.condition.criteria)(resObj));
			});

			this.simulatedItems = {
				targetIds: res?.targets?.map(f => f.Oid) || [],
				ruleIds: res?.rules?.map(f => f.Oid) || [],
				trackCriteriaParams: res.trackCriteriaParams
			}
			this.loadedTracks.filter(f => f.__countOfAllSubInsertions).map(f => {
				f.__skipPages = 0;
				f.__loadSubTracks(true);
			});
		}
	}
};
